import type { IReCaptchaComposition } from 'vue-recaptcha-v3'

export const useCaptchaStore = defineStore('captcha.store', () => {
  const { captchaType, siteKey } = storeToRefs(useLayoutStore())
  const nuxtApp = useNuxtApp()

  let reCaptcha: Undefinable<IReCaptchaComposition>

  const setReCaptcha = (instance: Undefinable<IReCaptchaComposition>) => {
    reCaptcha = instance
  }

  const runCaptcha = async () => {
    switch (captchaType.value) {
      case 'SMART_CAPTCHA':
        await waitFor(() => !!window.smartCaptcha)

        return new Promise<string>((resolve) => {
          const id = window.smartCaptcha.render('smart-captcha', {
            sitekey: siteKey.value,
            invisible: true,
            test: false, // если true, то всегда попросит решить задачку,
            callback: (token: string) => {
              window.smartCaptcha.destroy(id)
              resolve(token)
            },
          })

          window.smartCaptcha.execute(id)
          window.smartCaptcha.subscribe(id, 'challenge-hidden', () => {
            window.smartCaptcha.execute(id)
          })
        })

      case 'RECAPTCHA':
        if (!reCaptcha) break
        await reCaptcha.recaptchaLoaded()

        return await reCaptcha.executeRecaptcha('reCaptcha')
    }

    return 'invalid token'
  }

  const verifyToken = async (token: string) => {
    if (process.server) return
    try {
      const { data } = await nuxtApp.$api.resources.captcha.verify(token)

      localStorage.setItem('captcha_token', data.token)
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.log('error fetch scheme ', error)
      }

      throw error
    }
  }

  return {
    setReCaptcha,
    runCaptcha,
    verifyToken,
    captchaType,
  }
})
